import { ClaimError, Fulfillment } from '@bybeam/platform-types';
import useSubmitClaim from '@platform-ui-common/hooks/useSubmitClaim/index.js';
import { PaymentRail } from '@platform-ui-common/utilities/paymentMethods.js';
import GetUserApplicationsQuery from '@platform-ui/application/graphql/GetUserApplications.graphql';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';
import useSnackbar from '@platform-ui/common/hooks/useSnackbar/index.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { useHistory } from 'react-router';
import { ClaimPayload } from '../useClaim.js';

export const useSubmitWithRedirect = (
  fulfillment: Fulfillment,
  method: PaymentRail,
  payload: ClaimPayload,
): {
  submitClaim: () => Promise<void>;
  loading: boolean;
  error: ClaimError;
} => {
  const history = useHistory();
  const { showSnackbar, removeSnackbar } = useSnackbar();
  const { doMutation, error, loading } = useSubmitClaim({
    fulfillmentId: fulfillment.id,
    method,
    payload,
    refetchQueries: [GetUserApplicationsQuery],
  });
  const submitClaim = async (): Promise<void> => {
    const key = showSnackbar('Processing payment...');
    const success = await doMutation();
    removeSnackbar(key);
    if (success) history.push(makeRoute(ClaimRoutes.SUBMISSION, { fulfillmentId: fulfillment.id }));
  };
  if (!loading && error && !error.retryable)
    history.push(makeRoute(ClaimRoutes.ERROR, { fulfillmentId: fulfillment.id }));
  return { submitClaim, error, loading };
};

export default useSubmitWithRedirect;
